import { jsx as _jsx } from "react/jsx-runtime";
// useful if you have a lot of block elements inside a link and you don't want some of them to activate the link
export default function PreventDefaultClick(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx("div", {
    onClick: function onClick(e) {
      return e.preventDefault();
    },
    children: children
  });
}